<template>
  <div class="card card-container">
    <img loading="lazy" class="photo-person" :src="photos[item?.photo]" :alt="$t(`services.${item?.name}`)">
    <div class="content-card p-4">
      <h6 class="font-montserrat-b text-center mb-3">{{ $t(`services.${item?.name}`) }}</h6>
      <TrebolText
        v-for="(item, index) of item?.items"
        :key="index"
        :text="item[selectLanguage]"
      />
    </div>
  </div>
</template>

<script>
import ImageServiceOne from '@/assets/images/portrait-of-successful-farmer-cattleman-in-sheep-barn.jpg'
import ImageServiceTwo from '@/assets/images/speaker-on-the-stage-in-front-of-the-room-with-rear-view-of-audience-in-put-hand-up-acton.jpg'
import ImageServiceThree from '@/assets/images/form-img.jpg'
import TrebolText from '@/components/TrebolText.vue'
import { useAppStore } from '@/stores/app'
import { computed } from 'vue'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    TrebolText
  },
  setup() {
    const photos = {
      one: ImageServiceOne,
      two: ImageServiceTwo,
      three: ImageServiceThree,
    }

    const app = useAppStore()

    const selectLanguage = computed(() => {
      return app.language
    })

    return {
      photos,
      selectLanguage
    }
  }
}
</script>

<style scoped>
  .card-container {
    border: none;
    position: relative;
    overflow: hidden;
  }

  .card .photo-person {
    height: 15em;
    object-fit: cover;
    transition: transform .3s
  }

  .card .photo-person:hover {
    transform: scale(1.1);
  }

  .content-card {
    background-color: #f3f5f3;
  }

  .title-green {
    color: var(--secondary-color);
  }
</style>
